import React, { useState } from 'react';
import { Box, Typography, Switch, Paper } from '@mui/material';

const NotificationSettings = () => {
    const [notifications, setNotifications] = useState({
        notification: true,
        emailAlerts: true,
        candidateMessageAlerts: true
    });

    const handleToggle = (key) => {
        setNotifications(prev => ({
            ...prev,
            [key]: !prev[key]
        }));
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            {/* Notification Card */}
            <Paper
                elevation={0}
                sx={{
                    p: { xs: 2, md: 2.5 },    borderRadius: 2,
                    // border: '1px solid',
                    // borderColor: 'divider',
                    // bgcolor: 'background.paper',
                    display: 'flex',  alignItems: 'center', justifyContent: 'space-between',
                    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1)'
                }}
            >
                <Typography
                    variant="body1"
                    sx={{
                        fontWeight: 400,
                        color: 'text.primary',
                        fontSize: '14px'
                    }}
                >
                    Notification
                </Typography>
                <Switch checked={notifications.notification} onChange={() => handleToggle('notification')}
                    sx={{
                        '& .MuiSwitch-switchBase.Mui-checked': {
                            color: '#fff', '& + .MuiSwitch-track': { backgroundColor: 'primary.main', opacity: 1 },
                            '& .MuiSwitch-thumb': {
                                '&::after': { content: '""', position: 'absolute', width: '100%', height: '100%', backgroundSize: '12px 12px' }
                            }
                        },
                        '& .MuiSwitch-track': {  backgroundColor: 'rgba(0, 0, 0, 0.25)',  opacity: 1   }
                    }}
                />
            </Paper>

            {/* Email Alerts Card */}
            <Paper
                elevation={0}
                sx={{
                    p: 2.5,
                    borderRadius: 2,
                    // border: '1px solid',
                    // borderColor: 'divider',
                    // bgcolor: 'background.paper',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1)'
                }}
            >
                <Typography
                    variant="body1"
                    sx={{
                        fontWeight: 400,
                        color: 'text.primary',
                        fontSize: '14px'
                    }}
                >
                    Email alerts
                </Typography>
                <Switch
                    checked={notifications.emailAlerts}
                    onChange={() => handleToggle('emailAlerts')}
                    sx={{
                        '& .MuiSwitch-switchBase.Mui-checked': {
                            color: '#fff',
                            '& + .MuiSwitch-track': {
                                backgroundColor: 'primary.main',
                                opacity: 1
                            }
                        },
                        '& .MuiSwitch-track': {
                            backgroundColor: 'rgba(0, 0, 0, 0.25)',
                            opacity: 1
                        }
                    }}
                />
            </Paper>

            {/* Candidate Message Alerts Card */}
            <Paper
                elevation={0}
                sx={{
                    p: 2.5,
                    borderRadius: 2,
                    border: '1px solid',
                    borderColor: 'divider',
                    bgcolor: 'background.paper',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1)'
                }}
            >
                <Typography
                    variant="body1"
                    sx={{
                        fontWeight: 400,
                        color: 'text.primary',
                        fontSize: '14px'
                    }}
                >
                    Candidate message alerts
                </Typography>
                <Switch
                    checked={notifications.candidateMessageAlerts}
                    onChange={() => handleToggle('candidateMessageAlerts')}
                    sx={{
                        '& .MuiSwitch-switchBase.Mui-checked': {
                            color: '#fff',
                            '& + .MuiSwitch-track': {
                                backgroundColor: 'primary.main',
                                opacity: 1
                            }
                        },
                        '& .MuiSwitch-track': {
                            backgroundColor: 'rgba(0, 0, 0, 0.25)',
                            opacity: 1
                        }
                    }}
                />
            </Paper>
        </Box>
    );
};

export default NotificationSettings;

